<template>
  <div class="dict">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <!-- 委托加工入库单状态 -->
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('mcInboundEdit.title.entryListStatus') }}</div
          >
        </template>
        <div class="collapse-content">
          <EntryListStatus
            :canEdit="false"
            :dictList="dictList"
            @updateInvoice="updateInvoice"
            @resetRowInfo="resetRowInfo"
            ref="entryListStatus"
          />
        </div>
      </el-collapse-item>
      <!-- 基本信息 -->
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('mcInboundEdit.title.baseInfo') }}</div
          >
        </template>
        <div class="collapse-content">
          <BaseInfo
            :canEdit="canEdit"
            :costInfo="costInfo"
            :currencyList="currencyList"
            @updateInvoice="updateInvoice"
            @resetRowInfo="resetRowInfo"
            ref="baseInfo"
          />
        </div>
      </el-collapse-item>
      <!-- 费用明细 -->
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('mcInboundEdit.title.costInfo') }}</div
          >
        </template>
        <div class="collapse-content">
          <CostInfo
            :canEdit="canEdit"
            :lading="lading"
            :dictList="dictList"
            :validateInbound="validateInbound"
            @updatebaseInfo="updatebaseInfo"
            ref="costInfo"
          />
        </div>
      </el-collapse-item>
      <!-- 原材料行信息 -->
      <el-collapse-item name="4">
        <el-tabs type="border-card" v-model="activeNameTab" class="addCooperationTabs">
          <!-- 原材料行信息 -->
          <el-tab-pane name="first" :label="$t('mcInboundEdit.title.row')">
            <RowInfo
              :canEdit="canEdit"
              :dictList="dictList"
              :baseInfo="baseInfo"
              :validateInbound="validateInbound"
              :validateCost="validateCost"
              :getPickingTableInfo="getPickingTableInfo"
              @updateCostInfo="updateCostInfo"
              @restPickDetail="restPickDetail"
              ref="rowInfo"
            />
          </el-tab-pane>
          <!-- 拣配结果 -->
          <el-tab-pane name="pickingTab" :label="$t('mcInboundEdit.title.pickingTab')">
            <batch-matching-results
              :isEdit="canEdit"
              ref="pickingTab"
              :basicData="baseInfo"
              :storageLadingPickings="storageLadingPicking"
              :storageLadingPickingDetail="storageLadingPickingDetail"
              @calcLadingPicking="calcLadingPicking"
              @refreshData="refreshData"
              :deliveryMethod="baseInfo.deliveryMethod"
              :editConfigFlag="editConfigFlag"
            />
          </el-tab-pane>

          <el-tab-pane name="voucherTab" :label="$t('addInvoice.invoiceLine.title2')">
            <voucher
              ref="voucher"
              :voucherList="voucherList"
              @reverseInfo="reverseInfo"
              @postInfo="postInfo"
              @doConfirmInfo="doConfirmInfo"
            ></voucher>
          </el-tab-pane>
        </el-tabs>
      </el-collapse-item>
      <el-collapse-item name="5">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('applicationDetail.collapseTitle.fileTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <upload
            ref="upload"
            :isShow="canEdit && ['', 'MCZT01', 'MCZT04'].indexOf(baseInfo.inboundStatus) != -1"
            defaultPath="scm/mcInbound"
            :tableData="attachmentList"
            @upload="uploadList"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!-- 编辑 -->
      <el-button
        :disabled="
          (['MCZT01', 'MCZT04'].indexOf(baseInfo.inboundStatus) == -1 && !canEdit) ||
          !baseInfo.inboundStatus
        "
        type="primary"
        @click="edit"
        v-hasPermi="['2021050814230201410']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.edit') }}
      </el-button>

      <!-- 保存 -->
      <el-button
        :disabled="['', 'MCZT01', 'MCZT04'].indexOf(this.baseInfo.inboundStatus) == -1 || !canEdit"
        type="primary"
        @click="save"
        :loading="load"
        v-hasPermi="['2021050814233041202']"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.save') }}
      </el-button>
      <!-- 提交 -->
      <el-button
        :disabled="['', 'MCZT01', 'MCZT04'].indexOf(this.baseInfo.inboundStatus) == -1"
        type="primary"
        @click="submit"
        v-hasPermi="['2021050814234019009']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.submission') }}
      </el-button>
      <!-- 确认 -->
      <el-button
        :disabled="['MCZT03'].indexOf(this.baseInfo.inboundStatus) == -1"
        type="primary"
        @click="doConfirm"
        v-hasPermi="['2021050814241724432']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.confirm') }}
      </el-button>
      <!-- 打印 -->
      <el-button
        type="primary"
        @click="print"
        v-hasPermi="['2021050814243880042']"
        class="fixed-bottom-btn"
        >{{ this.$t('transportOrderAdd.btnList.print') }}</el-button
      >
      <!-- v-if="this.baseInfo.inboundStatus=='TDZT03' || this.baseInfo.inboundStatus=='TDZT07'" -->
      <!-- 撤销 -->
      <el-button
        :disabled="['MCZT03'].indexOf(this.baseInfo.inboundStatus) == -1"
        type="primary"
        @click="withdraw"
        v-hasPermi="['2021050814245079025']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.withdraw') }}
      </el-button>
      <!-- 删除 -->
      <el-button
        :disabled="['MCZT01', 'MCZT04'].indexOf(this.baseInfo.inboundStatus) == -1"
        type="primary"
        @click="deleteRecord"
        v-hasPermi="['2021050814250108890']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.delete') }}
      </el-button>
      <!-- 生成凭证 -->
      <el-button
        :disabled="
          ['MCZT05'].indexOf(this.baseInfo.inboundStatus) == -1 ||
          ['notgenerate', 'generated', 'postError'].indexOf(this.baseInfo.accountingStatus) == -1
        "
        type="primary"
        @click="handleAccountEntry"
        v-hasPermi="['2021050814253654723']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.accountEntry') }}
      </el-button>
      <!-- 过账凭证 -->
      <el-button
        :disabled="
          ['MCZT05'].indexOf(this.baseInfo.inboundStatus) == -1 ||
          ['generated', 'postError'].indexOf(this.baseInfo.accountingStatus) == -1
        "
        type="primary"
        @click="doSyncVoucherForEntityData()"
        v-hasPermi="['2021050814254576259']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.doSyncVoucherForEntityData') }}
      </el-button>
      <!-- 冲销 -->
      <el-button
        :disabled="['MCZT05'].indexOf(this.baseInfo.inboundStatus) == -1"
        type="primary"
        @click="doReverseAccountEntry()"
        :loading="load"
        v-hasPermi="['2021050814255756020']"
        class="fixed-bottom-btn"
        >{{ this.$t('mcInboundEdit.btns.writeOff') }}
      </el-button>
    </div>
    <print-dialog
      ref="printDialog"
      :id="String($route.query.id)"
      :deleveryFlag="this.deleveryFlag"
    ></print-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import EntryListStatus from './components/entryListStatus';
  import BaseInfo from './components/baseInfo';
  import CostInfo from './components/costInfo';
  import RowInfo from './components/rowInfo';
  import batchMatchingResults from './components/batchMatchingResults';
  import API from '@/api/wareHouse/mcInbound.js';
  // import { delcommafy } from '@/common/js/util';
  // import BASE_API from '@/api/dataBase';
  import loading from '@/common/js/load.js'; //loading
  import voucherMixins from '@/common/mixins/voucher.js';
  import Upload from '@/components/upload';
  import printDialog from './components/printDialog';
  import XEUtils from 'xe-utils';
  export default {
    mixins: [voucherMixins],
    components: {
      EntryListStatus,
      BaseInfo,
      CostInfo,
      RowInfo,
      batchMatchingResults,
      Upload,
      printDialog,
    },
    name: 'baseMcInbound',
    data() {
      return {
        activeNameTab: 'first',
        voucherList: [], //凭证列表
        load: false,
        activeNames: ['1', '2', '3', '4', '5', '6'], //默认展开那些面板，
        storageLadingPicking: [], //商品明细
        storageLadingPickingDetail: [], //商品明细拣配结果
        editConfigFlag: false,
        type: false,
        canEdit: this.$route.query.isEdit == 'Y',
        contractNo: this.$route.query.contractNo,
        contractDetailNo: this.$route.query.contractDetailNo,
        taxRateList: [], //率
        companyTree: [], // 部门数
        menuButtonList: [],
        payList: [], //付款信息
        defaultVisible: false, //匹配采购合同
        attachmentList: [],
        checkRowKeys: [],
        baseInfo: {
          inboundStatus: '',
        }, //基本信息
        currencyList: [],
        lading: {
          ladingPrice: '',
          ladingQuantity: '',
        },
        costInfo: {},
        deleveryFlag: false,
        voucherFlag: 'AE_PO_MC_INBOUND', //凭证标识
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList() {
          let obj = {
            reverseFlagOptions: this.$baseRequest.getDictListMapByType('reverseFlag'),
            unitOptions: this.$baseRequest.getDictListMapByType('basic_unit'),
            inboundStatus: this.$baseRequest.getDictListMapByType('mc_inbound_status'),
            contractType: this.$baseRequest.getDictListMapByType(
              'purchase_contract_detail_category'
            ),
            taxRateList: this.$baseRequest.getDictListMapByType('tax_rate'),
          };
          return obj;
        },
      }),
    },
    watch: {},
    mounted() {
      // this.getCurrencyList()

      //制单人默认
      // const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd')
      const userInfo = {
        userCode: this.userInfo.userCode,
        userName: this.userInfo.userName,
      };
      this.baseInfo.inboundCreatePersonNo = userInfo.userCode;
      this.baseInfo.inboundCreatePersonName = userInfo.userName;
      this.baseInfo.businessPersonNo = userInfo.userCode;
      this.baseInfo.businessPersonName = userInfo.userName;
      // this.baseInfo.inboundCreateDate = date //制单日期

      // this.baseInfo.exchangeDate = date
      // this.baseInfo.belongDate = date
      // this.baseInfo.invoiceSource = "3"

      this.$refs.baseInfo.formData = Object.assign(this.$refs.baseInfo.formData, this.baseInfo);
      console.log(this.$refs.baseInfo.formData);
      const query = this.$route.query;
      // this.baseInfo.id = query['id']
      if (query) {
        this.getDetail();
      } else {
        // 新增情况下需监听字段变化
        this.$refs.baseInfo.initFlag = false;
      }
    },
    methods: {
      // 更新基本信息中由费用明细带入的值
      updatebaseInfo(costInfo) {
        this.costInfo = costInfo;
        console.log(this.costInfo);
      },
      updateCostInfo(rowAmount) {
        // console.log(rowAmount);
        // this.$refs.costInfo.ladingPrice=rowAmount.ladingPrice||'';
        // this.$refs.costInfo.ladingQuantity=rowAmount.ladingQuantity||'';
        this.lading = {
          ladingPrice: rowAmount.ladingPrice,
          ladingQuantity: rowAmount.ladingQuantity,
        };
        // console.log(this.lading);

        this.storageLadingPicking = this.$refs.rowInfo.$refs.ruleTable.getTableData().fullData;
      },

      // 重置拣配结果
      restPickDetail(inboundPickNoList) {
        console.log(inboundPickNoList);
        if (inboundPickNoList == '999') {
          //修改出库仓库，清空所有行信息和拣配结果
          this.storageLadingPicking = [];
          this.storageLadingPickingDetail = [];
        } else if (typeof inboundPickNoList == 'string') {
          //修改某一行信息，删除对应的拣配结果明细
          let pickingTableInfo = this.getPickingTableInfo();
          // this.storageLadingPicking = pickingTableInfo.storageLadingPickingList.filter(item=>item.inboundPickNo!=inboundPickNoList)
          this.storageLadingPickingDetail = pickingTableInfo.storageLadingPickingDetailList.filter(
            (item) => item.inboundPickNo != inboundPickNoList
          );
        } else {
          //删除一行或多行信息，删除对应的拣配结果
          let pickingTableInfo = this.getPickingTableInfo();
          this.storageLadingPicking = pickingTableInfo.storageLadingPickingList;
          this.storageLadingPickingDetail = pickingTableInfo.storageLadingPickingDetailList;
          //拣配结果对象删除 对应的原材料行
          inboundPickNoList.forEach((item, i) => {
            this.storageLadingPicking = this.storageLadingPicking.filter(
              (item) => item.inboundPickNo != inboundPickNoList[i]
            );
            this.storageLadingPickingDetail = this.storageLadingPickingDetail.filter(
              (item) => item.inboundPickNo != inboundPickNoList[i]
            );
          });
        }

        console.log(this.storageLadingPicking);
        console.log(this.storageLadingPickingDetail);
      },
      // 获取委托加工入库单详情
      getDetail() {
        let url = '';
        const query = this.$route.query;
        // const name = this.$route.name;
        // const userBaseInfo = this.userBaseInfo;
        console.log(query);
        if (query.id) {
          console.log(query.id);
          url = API.QUERY_DATA_DETAIL;
          this.$axios.get(url, { id: query.id }).then((res) => {
            if (res.data.code == 0) {
              console.log(res.data);
              const data = res.data.data;
              if (!data.inboundStatus) data.inboundStatus = '';
              this.baseInfo = Object.assign({}, data);
              this.attachmentList = this.baseInfo.returnInboundAttachmentList || [];
              this.baseInfo.instructionNo = query.instructionNo;
              console.log(this.baseInfo);
              this.$refs.baseInfo.getDetail(this.baseInfo);
              this.$refs.entryListStatus.getDetail(this.baseInfo);
              let tableData = [data.inboundDetail];
              console.log(tableData);
              console.log(this.$refs.baseInfo);
              this.$refs.costInfo.tableData = tableData;
              this.$refs.costInfo.tableData[0].contractType = this.dictList.contractType.find(
                (item) => item.value == 'HT10'
              ).label;
              console.log(this.$refs.costInfo.tableData[0].contractType);
              this.$refs.rowInfo.tableData = data.inboundPickingList;
              this.storageLadingPickings = data.inboundPickingList || [];
              this.storageLadingPickingDetail = data.inboundPickingDetailList || [];
              // 获取凭证ID 获取凭证列表
              this.entityDataId = data.id;
              this.getAccountEntry();
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
        if (query.contractNo) {
          this.canEdit = true;
          console.log(query.contractNo);
          console.log(query.contractDetailNo);
          url = API.GET_DATA_DETAIL;
          this.$axios
            .get(url, { contractNo: query.contractNo, contractDetailNo: query.contractDetailNo })
            .then((res) => {
              if (res.data.code == 0) {
                console.log(res.data);
                const data = res.data.data;
                if (!data.inboundStatus) data.inboundStatus = '';
                this.baseInfo = Object.assign({}, data);
                this.attachmentList = [];
                this.baseInfo.instructionNo = query.instructionNo;
                this.baseInfo.inboundCreatePersonNo = this.userInfo.userCode; //制单人
                this.baseInfo.inboundCreatePersonName = this.userInfo.userName;
                // this.baseInfo.businessPersonNo = this.userInfo.userCode;
                // this.baseInfo.businessPersonName = this.userInfo.userName;
                const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
                this.baseInfo.inboundCreateDate = date; //制单日期
                console.log(this.baseInfo);
                this.$refs.baseInfo.getDetail(this.baseInfo);
                this.$refs.entryListStatus.getDetail(this.baseInfo);
                let tableData = [data.inboundDetail];
                console.log(tableData);
                console.log(this.$refs.baseInfo);
                this.$refs.costInfo.tableData = tableData;
                this.$refs.costInfo.tableData[0].contractType = this.dictList.contractType.find(
                  (item) => item.value == 'HT10'
                ).label;
                console.log(this.$refs.costInfo.tableData[0].contractType);
                // 获取公司本位币
                this.$baseRequest.getLedger(this.baseInfo.inboundCompanyCode).then((res) => {
                  if (res.length > 0) {
                    //如果换公司，则币种都默认变化
                    this.baseInfo.companyCurrencyCode = res[0].currencyCode;
                    this.baseInfo.companyCurrencyName = res[0].currencyName;
                  } else {
                    //没有查询到公司账套
                    this.baseInfo.companyCurrencyCode = null;
                    this.baseInfo.companyCurrencyName = null;
                    this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
                  }
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
        }
      },

      // 获取拣配TAB信息
      getPickingTableInfo() {
        return this.$refs.pickingTab.exportTableData();
      },

      // 校验基本信息
      validateInbound() {
        return new Promise((resolve, reject) => {
          this.$refs.baseInfo
            .getVal()
            .then(() => {
              console.log('validateInboundSuc');
              resolve(true);
            })
            .catch(() => {
              console.log('validateInbounderr');
              reject();
            });
        });
        // if(!flag) return
        /* return new Promise((resolve, reject) => {
        this.$refs.baseInfo.$refs.topData.$refs['ruleForm'].validate(validate=>{
          validate?resolve(true):resolve(false)
        })
      }) */
      },
      // 校验费用明细
      validateCost() {
        console.log(this.$refs.costInfo);
        return new Promise((resolve, reject) => {
          this.$refs.costInfo.$refs.ruleTable.validate((validate) => {
            validate ? resolve(true) : reject();
          });
        });
      },
      // // 出库仓库改变，清空原材料行明细以及拣配结果
      updateInvoice(baseInfo, prop) {
        this.baseInfo = baseInfo;
        if (prop == 'outboundStorageName') {
          let msg = '修改出库仓库，原材料行信息、拣配结果将会全部清空!';
          let title = '是否确认修改？';
          console.log(this.$refs.rowInfo.tableData == '');
          if (this.$refs.rowInfo.tableData == '') return;
          this.$confirmAction(msg, title)
            .then(() => {
              this.restPickDetail(999);
              this.resetRowInfo();
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('message.success'),
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('message.cancle'),
              });
            });
        }
      },

      //拣配后 原材料总金额发生变化
      calcLadingPicking(storageLadingPickingList) {
        let materialAmount = 0;
        storageLadingPickingList.map((item) => {
          materialAmount = this.$cal.calCommon(materialAmount, item.ladingAmount, '+');
        });
        //原材料总金额
        this.$refs.costInfo.tableData[0].materialAmount = materialAmount;
        //商品总金额=不含税加工费+原材料总金额
        this.$refs.costInfo.tableData[0].settlementAmount = this.$cal.calCommon(
          this.$refs.costInfo.tableData[0].mcAmountWithoutTax || 0,
          materialAmount || 0,
          '+',
          'amount'
        );
        //商品结算价=商品总金额/商品数量
        this.$refs.costInfo.tableData[0].settlementPrice = this.$cal.calCommon(
          this.$refs.costInfo.tableData[0].settlementAmount || 0,
          this.$refs.costInfo.tableData[0].inboundQuantity,
          '/',
          'price'
        );
        // 含税产成品总金额 = 不含税产成品总金额*(1+税率）
        let step1 = this.$cal.calCommon(1, this.$refs.costInfo.tableData[0].taxRate, '+', ''); //(1+税率）
        this.$refs.costInfo.tableData[0].productAmountWithTax = this.$cal.calCommon(
          this.$refs.costInfo.tableData[0].settlementAmount || 0,
          step1,
          '*',
          'amount'
        );
        // 产成品税额 = 含税产成品总金额-不含税产成品总金额
        this.$refs.costInfo.tableData[0].productTaxAmount = this.$cal.calCommon(
          this.$refs.costInfo.tableData[0].productAmountWithTax,
          this.$refs.costInfo.tableData[0].settlementAmount,
          '-',
          'amount'
        );
        // 更新行信息总计信息
        this.$refs.rowInfo.$refs.ruleTable.updateFooter();
      },
      refreshData(obj) {
        console.log(obj);
      },
      // // 重置行信息
      resetRowInfo() {
        this.$refs.rowInfo.tableData = [];
      },

      handleClick(item) {
        console.log(item);
        switch (item.buttonUrl) {
          case 'save':
            this.save();
            break;
          case 'withdraw':
            this.withdraw();
            break;
          case 'generatePaymentDocument':
            this.save('generatePayment');
            break;
          case 'print':
            this.print();
            break;
        }
      },
      // 打印
      print() {
        this.$refs.printDialog.openDialog(true);
      },

      //更新附件列表
      uploadList(value) {
        this.attachmentList = [];
        if (value.length) {
          value.map((item) => {
            this.attachmentList.push({
              ...item,
            });
          });
        }
      },
      // // 提交
      submit() {
        const p1 = this.validateInbound();
        const p2 = new Promise((resolve, reject) => {
          this.$refs['rowInfo'].$refs['ruleTable'].validate((valid) => {
            valid ? resolve() : reject();
          });
        });
        const p3 = new Promise((resolve, reject) => {
          this.$refs['costInfo'].$refs['ruleTable'].validate((valid) => {
            valid ? resolve() : reject();
          });
        });
        let url = this.baseInfo.id ? API.UPDATE_SUBMIT : API.SAVE_SUBMIT;
        console.log(url);
        let inboundDetail = this.$refs.costInfo.exportTableData()[0] || {}; //费用明细
        let inboundPickingList =
          this.$refs.pickingTab.exportTableData().storageLadingPickingList || []; //原材料明细
        let inboundPickingDetailList =
          this.$refs.pickingTab.exportTableData().storageLadingPickingDetailList || []; //拣配结果
        Promise.all([p1, p2, p3]).then(() => {
          let params = {
            ...this.$refs.baseInfo.formData,
            inboundDetail,
            inboundPickingList,
            inboundPickingDetailList,
            saveUpdate: 2,
            id: this.baseInfo.id || null,
            lastModifiedBy: this.userInfo.userCode,
            inboundAttachmentList: this.attachmentList,
            submitFlag: 1,
          };
          params = this.$baseRequest.assignObj(params);
          console.log(params);
          loading.startLoading();
          this.$axios
            .post(url, params)
            .then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.goBack();
                this.$message({
                  showClose: true,
                  message: this.$t('message.success'),
                  type: 'success',
                });
              } else {
                if (res.data.data) {
                  this.$message({ showClose: true, message: res.data.msg, type: 'error' });
                  const data = res.data.data;
                  if (!data.inboundStatus) data.inboundStatus = '';
                  this.baseInfo = Object.assign({}, data);
                  this.$refs.baseInfo.getDetail(this.baseInfo);
                  this.baseInfo.inboundQuantity = data.inboundDetail.inboundQuantity;
                  this.baseInfo.settlementPrice = data.inboundDetail.settlementPrice;
                  this.baseInfo.settlementAmount = data.inboundDetail.settlementAmount;
                  this.$refs.rowInfo.tableData = data.mcInboundEditDetailLsit;
                  let tableData = [data.inboundDetail];
                  this.$refs.costInfo.tableData = tableData;
                  this.$refs.rowInfo.tableData = data.inboundPickingList;
                  this.storageLadingPickings = data.inboundPickingList;
                  this.storageLadingPickingDetail = data.inboundPickingDetailList;
                } else {
                  this.$message({ showClose: true, message: res.data.msg, type: 'error' });
                }
              }
            })
            .catch(() => loading.endLoading());
        });
      },
      // 保存
      save() {
        const p1 = this.validateInbound();
        const p2 = new Promise((resolve, reject) => {
          this.$refs['rowInfo'].$refs['ruleTable'].validate((valid) => {
            valid ? resolve() : reject();
          });
        });
        const p3 = new Promise((resolve, reject) => {
          this.$refs['costInfo'].$refs['ruleTable'].validate((valid) => {
            valid ? resolve() : reject();
          });
        });
        let url = this.baseInfo.id ? API.UPDATE_SUBMIT : API.SAVE_SUBMIT;
        console.log(url);
        console.log(this.$refs.entryListStatus.formData);
        let inboundDetail = this.$refs.costInfo.exportTableData()[0] || {}; //费用明细
        let inboundPickingList =
          this.$refs.pickingTab.exportTableData().storageLadingPickingList || []; //原材料明细
        let inboundPickingDetailList =
          this.$refs.pickingTab.exportTableData().storageLadingPickingDetailList || []; //拣配结果
        console.log(inboundPickingDetailList);
        Promise.all([p1, p2, p3]).then(() => {
          let params = {
            ...this.$refs.baseInfo.formData,
            inboundDetail,
            inboundPickingList,
            inboundPickingDetailList,
            id: this.baseInfo.id || null,
            lastModifiedBy: this.userInfo.userCode,
            inboundAttachmentList: this.attachmentList,
            saveUpdate: 1,
            submitFlag: 0,
          };
          // if(params.invoiceType=="creditMemo" && params.invoiceAmount>=0){
          //   this.$message({
          //     showClose: true,
          //     message: this.$t("mcInboundEdit.warnInfo.needLowZero"),
          //     type: "error"
          //   });
          //   return;
          // }else if(params.invoiceType=="invoice" && params.invoiceAmount<=0){
          //   this.$message({
          //     showClose: true,
          //     message: this.$t("mcInboundEdit.warnInfo.needOverZero"),
          //     type: "error"
          //   });
          //   return;
          // }
          // params.mcInboundEditDetailLsit.map((item,index)=>{
          //   item["invoiceDetailCode"] = index+1
          //   item = this.$baseRequest.assignObj(item)
          //   return item;
          // })
          params = this.$baseRequest.assignObj(params);
          loading.startLoading();
          this.$axios
            .post(url, params)
            .then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                const data = res.data.data;
                if (!data.inboundStatus) data.inboundStatus = '';
                this.baseInfo = Object.assign({}, data);
                this.$refs.baseInfo.getDetail(this.baseInfo);
                this.baseInfo.inboundQuantity = data.inboundDetail.inboundQuantity;
                this.baseInfo.settlementPrice = data.inboundDetail.settlementPrice;
                this.baseInfo.settlementAmount = data.inboundDetail.settlementAmount;
                this.$refs.rowInfo.tableData = data.mcInboundEditDetailLsit;
                let tableData = [data.inboundDetail];
                this.$refs.costInfo.tableData = tableData;
                this.$refs.rowInfo.tableData = data.inboundPickingList;
                this.storageLadingPickings = data.inboundPickingList;
                this.storageLadingPickingDetail = data.inboundPickingDetailList;
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            })
            .catch(() => loading.endLoading());
        });
      },

      // 编辑
      edit() {
        this.canEdit = true;
      },

      // 确认
      doConfirmInfo(info) {
        let params = { id: this.baseInfo.id, inboundNo: this.baseInfo.inboundNo, ...info };
        this.$axios.post(API.DO_CONFIRM, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t('message.success'),
              type: 'success',
            });
            this.getDetail();
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },

      // 撤销
      withdraw() {
        let params = {
          //撤回所需参数
          id: this.baseInfo.id,
          //检查关联结算批次所需参数
          ...this.checkSettleParams,
        };
        this.$baseRequest
          .doWithdrawCommon(API.WITHDRAW_INVOICE, params)
          .then(() => {
            this.getDetail();
          })
          .catch((e) => {
            console.log(e);
          });
      },

      // 删除
      deleteRecord() {
        this.$confirmAction()
          .then(() => {
            loading.startLoading();
            this.$axios.post(API.DELETE_INVOICE, [this.baseInfo.id]).then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.goBack();
                this.$message({ showClose: true, message: this.$t('message.success') });
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          })
          .catch(() => {
            loading.endLoading();
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },

      // 返回
      goBack() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: this.$t('currenciesAndCalendar.addCurrencies.addCurrencies'),
            },
          },
          toPath: {
            path: '/wareHouse/mcInboundList',
            name: 'mcInboundList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .deliveryOrderTop {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 26px 10px 11px 10px;
  }
</style>
